<template>
  <span>
    <el-select v-if="mode=='select' && !multiple" v-model="selectedVal" :placeholder="placeholder" :disabled="disabled" filterable style="width:100%">
      <el-option v-for="item in options" :key="item.dataDictItemCode" :label="item.dataDictItemName" :value="item.dataDictItemCode+':'+item.dataDictItemName+(item.colorValue==null ? '' :':'+ item.colorValue)" />
    </el-select>
    <el-select v-if="mode=='select' && multiple" v-model="selectedVal" :placeholder="placeholder" :disabled="disabled" multiple collapse-tags filterable style="width:100%">
      <el-option
        v-for="item in options"
        :key="item.dataDictItemCode"
        :label="item.dataDictItemName"
        :value="item.dataDictItemCode+':'+item.dataDictItemName+(item.colorValue==null ? '' :':'+ item.colorValue)" />
    </el-select>
    <el-radio-group v-if="mode=='radio'" v-model="selectedVal">
      <el-radio
        v-for="item in options"
        :key="item.dataDictItemCode"
        :label="item.dataDictItemCode+':'+item.dataDictItemName+(item.colorValue==null ? '' :(':'+ item.colorValue))">
        {{ item.dataDictItemName }}
      </el-radio>
    </el-radio-group>
  </span>
</template>
<script>
// import docAnalysisService from "@/service/doc-analysis"
export default {
  props: {
    value: {
      type: [String, Array],
      default() {
        return ''
      }
    },
    mode: {
      type: String,
      default() {
        return 'select'
      }
    },
    placeholder: {
      type: String,
      default() {
        return '请选择'
      }
    },
    code: { type: String, required: true },
    multiple: {
      type: Boolean,
      default() {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    filterData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      typeGroupCode: this.code,
      selectedVal: '',
      options: []
    }
  },
  watch: {
    value: function(val) {
      setTimeout(() => {
        this.selectedVal = val
      }, 200)
    },
    selectedVal: function(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    this.selectedVal = this.value
  },
  methods: {
    async initData() {
      try {
        const response = await this.$store.dispatch('findDataDictByCode', this.typeGroupCode)
        let dataDictItemVos = response
        if (this.filterData.length > 0) {
          dataDictItemVos = dataDictItemVos.filter(arrItem => {
            return this.filterData.includes(arrItem.dataDictItemCode)
          })
        }
        this.options = dataDictItemVos
      } catch (_) {
        console.log()
      }
      // this.treeData = response
    }
  }
}
</script>
<style lang="scss">
</style>
